import { useCallback, useState } from 'react';

export function useForceUpdate(): () => void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [, setState] = useState<any>();
  const forceUpdate = useCallback(() => setState({}), []);

  return forceUpdate;
}
